import React, { Component } from 'react';
import {List, Toast, WingBlank} from 'antd-mobile';
import send from '../../../utils/send';
import ListImg from '../../../components/ListImg'

export default class FarmList extends Component {
  constructor (props) {
    super(props);
    this.state = {
      list: []
    }
  }
  onClick = o => {
    this.props.history.replace({
      pathname: '/createfarm/farm_edit',
      state: o
    })
  };
  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    Toast.loading('请稍等',5);
    let res = await send({
      url: '/api/forward/ifarm/simpleFarm/list',
      method: 'GET'
    });
    if (res.status === 200) {
     const data = res.data;
     this.setState({
       list: data
     })
   }
    Toast.hide()
  };
 render() {
  return (
    <WingBlank size={'md'}>
      {
        this.state.list.length === 0 && <ListImg />
      }
      {
        this.state.list.map((o,index) => {
          return <div className={'farm-list round-list'}
              key={index}
              onClick={() => {
            this.onClick(o)
          }
          }
                 >
            <List.Item className={'list-item'}>
              <i className={'farm-icon'}/>
              {o.nameLoc}
            </List.Item>
            <List.Item className={'list-item'}
                extra={o.managerName}
            >
              负责人
            </List.Item>
            <List.Item className={'list-item'}
                extra={o.phoneNo}
            >
              电话
            </List.Item>
            <List.Item className={'list-item span-5'}
                extra={o.gpsLocation}
            >
              地址
            </List.Item>
          </div>
        })
      }

    </WingBlank>
  )
 }
}
